import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import type { Nullable } from "@core/domain/types/nullable.type";
import type { Farm } from "@farm/domain/models/farm.model";
import type { FarmRepository } from "@farm/domain/repositories/farm.repository";
import { farmTypes } from "@farm/farm-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class FarmGetByIdUseCase {
    constructor(
        @inject(farmTypes.repositories.FarmRepository)
        private readonly farmRepository: FarmRepository,
    ) {}

    async execute(farmId: number): Promise<Nullable<Farm>> {
        const farmResult = await this.farmRepository.getById(farmId);

        return farmResult.match<Nullable<Farm>>(
            (farm) => farm,
            (error) => {
                ToastManagerRepository.error(error.message);
                return null;
            },
        );
    }
}
